import { render, staticRenderFns } from "./ListClients.vue?vue&type=template&id=5c3adc5b&scoped=true&"
import script from "./ListClients.vue?vue&type=script&lang=js&"
export * from "./ListClients.vue?vue&type=script&lang=js&"
import style0 from "./ListClients.vue?vue&type=style&index=0&id=5c3adc5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3adc5b",
  null
  
)

export default component.exports